<template>
	<div class="animated fadeIn">
		<b-card>
			<b-card-header>
				<i class="icon-menu mr-1"></i>廠牌列表
				<div class="card-header-actions">
					<b-link @click="openEditor()" v-if="!cannotEdit"><i class="fa fa-plus"></i> 新增</b-link>
				</div>
			</b-card-header>
		  <b-card-body>
			<v-server-table :columns="columns" :data="data" :options="options" :theme="theme" ref="dataTable" id="dataTable">
				<a slot="name" slot-scope="props">{{props.row.name ? props.row.name : '未連結'}}</a>
				<a slot="company_id" slot-scope="props">{{props.row.Company?props.row.Company.name:'N/A'}}</a>
				<a slot="access_rules" slot-scope="props">{{getAccessRules(props.row.access_rules)}}</a>

				
				<div slot="child_row" slot-scope="props">
					<b-button variant="info" class="btn-pill" size="sm" v-if="!cannotEdit" @click="editRow(props.row.id, props.row)"><i class="fa fa-pencil"></i> 編輯</b-button> &nbsp;
					<b-button variant="danger" class="btn-pill" size="sm" v-if="!cannotEdit" @click="delRow(props.row.id, props.row.name)"><i class="fa fa-times"></i> 刪除</b-button> &nbsp;
				</div>
			</v-server-table>
		  </b-card-body>
		</b-card>

		<b-modal title="刪除裝置" size="sm" v-model="delRowShowModal" @ok="submitDelRow(delRowId)" ok-title="確定" cancel-title="取消">
	   {{delRowMsg}}
		</b-modal>

		<b-modal title="編輯器" size="lg" class="modal-info" v-model="showEditorModal" @ok="submitRecord" ok-title="儲存" cancel-title="取消" :ok-disabled="$v.$invalid">
			<b-form>
			  <h1>廠牌資料</h1>
			  <p class="text-muted">綠框為必填</p>
			  <b-input-group class="mb-3">
				<b-input-group-prepend>
					<b-input-group-text><i class="fa fa-clone"></i></b-input-group-text>
				</b-input-group-prepend>
				<b-form-input type="text" 
							  class="form-control" 
							  placeholder="名稱" 
							  v-model.lazy.trim="$v.record.name.$model"
							  v-focus
							  :state="chkState('name')"
							  aria-describedby="invalidNameFeedback"/>
				<b-form-invalid-feedback id="invalidNameFeedback">名稱必填</b-form-invalid-feedback>
			  </b-input-group>

			  <b-input-group class="mb-4">
				<b-input-group-prepend>
				  <b-input-group-text><i class="fa fa-usd"></i>電源</b-input-group-text>
				</b-input-group-prepend>
				<v-select v-model.lazy.trim="$v.record.select_power.$model"
					:options="power_options"
					:reduce="option => option.value"
					placeholder="請選擇電源" 
					:state="chkState('select_power')"/>
			  </b-input-group>
			  <!--<b-input-group class="mb-4">
				<b-input-group-prepend>
				  <b-input-group-text><i class="fa fa-usd"></i>電源</b-input-group-text>
				</b-input-group-prepend>
				<v-select v-model="edit_power" :options="power_options" placeholder="請選擇電源"></v-select>
			  </b-input-group>-->

			  <b-input-group v-if="record.select_power && record.select_power.value=='AC'" class="mb-4">
				<b-input-group-prepend>
					<b-input-group-text><i class="icon-call-out icons"></i>充電電壓(V)</b-input-group-text>
				</b-input-group-prepend>
				<b-form-input type="number" 
							  class="form-control" 
							  placeholder="請輸入電壓" 
							  v-model.lazy.trim="record.voltage"/>
			  </b-input-group>

			  <b-input-group v-if="record.select_power && record.select_power.value=='AC'" class="mb-4">
				<b-input-group-prepend>
					<b-input-group-text><i class="icon-call-out icons"></i>充電電流(A)</b-input-group-text>
				</b-input-group-prepend>
				<b-form-input type="number" 
							  class="form-control" 
							  placeholder="請輸入電流" 
							  v-model.lazy.trim="record.current_rating"/>
			  </b-input-group>

			  <b-input-group class="mb-4">
				<b-input-group-prepend>
					<b-input-group-text><i class="icon-call-out icons"></i>充電功率(kW)</b-input-group-text>
				</b-input-group-prepend>
				<b-form-input type="number" 
							  class="form-control" 
							  placeholder="請輸入功率"
							  v-model.lazy.trim="$v.record.power_rating.$model"
							  v-focus
							  :state="chkState('power_rating')"
							  aria-describedby="invalidPowerRatingFeedback"/>
				<b-form-invalid-feedback id="invalidPowerRatingFeedback">功率必填</b-form-invalid-feedback>
			  </b-input-group>

			  <b-input-group class="mb-4">
				<b-input-group-prepend>
					<b-input-group-text><i class="icon-call-out icons"></i>充電槍個數</b-input-group-text>
				</b-input-group-prepend>
				<b-form-input type="number" 
							  class="form-control" 
							  placeholder="請輸入個數"
							  v-model.lazy.trim="$v.record.num_of_connector.$model"
							  v-focus
							  :state="chkState('num_of_connector')"
							  aria-describedby="invalidNumConnectorFeedback"
							  min="1"
							  max="2"/>
				<b-form-invalid-feedback id="invalidNumConnectorFeedback">充電槍個數必填</b-form-invalid-feedback>
			  </b-input-group>

			  <b-input-group class="mb-4">
				<b-input-group-prepend>
				  <b-input-group-text><i class="fa fa-usd"></i>充電槍1</b-input-group-text>
				</b-input-group-prepend>
				<v-select v-model="edit_connector1_type" :options="connector_type_options" placeholder="請選擇類型"></v-select>
			  </b-input-group>

			  <b-input-group v-if="record.select_power && record.select_power.value=='DC'" class="mb-4">
				<b-input-group-prepend>
				  <b-input-group-text><i class="fa fa-usd"></i>充電槍2</b-input-group-text>
				</b-input-group-prepend>
				<v-select v-model="edit_connector2_type" :options="connector_type_options" placeholder="請選擇類型"></v-select>
			  </b-input-group>

			  <b-input-group class="mb-4">
				<b-input-group-prepend>
					<b-input-group-text><i class="icon-notebook icon"></i></b-input-group-text>
				</b-input-group-prepend>
				<b-form-textarea
					 v-model.lazy.trim="record.remarks"
					 placeholder="備註"
					 :rows="3"
					 :max-rows="6">
				</b-form-textarea>
			  </b-input-group>
			</b-form>
		</b-modal>
	</div>
</template>

<script>
import Vue from 'vue'
import {ServerTable, Event} from 'vue-tables-2'
import { required, minLength, between, email, minValue, integer } from 'vuelidate/lib/validators'
import Multiselect from 'vue-multiselect'
import vSelect from 'vue-select'
import config from '@/config/global'
import notifications from '@/config/notifications'
import jQuery from 'jquery'
import select2 from 'select2'
// import qrcode from 'qrcode'
import sha1 from 'sha1'
import io from 'socket.io-client'
import _ from 'lodash'
import moment from 'moment-timezone'
import QRious from 'qrious'

const encrypt	 = config.encrypt;
const decrypt	 = config.decrypt;
const admin_root = config.admin_root;

let $socket = null;

const clean_form = {
	name:		  '',
	power:	'AC',
	select_power:	   {label:'AC', value:'AC'},
	voltage:	220,
	current_rating: 32,
	power_rating: 7,
	num_of_connector: 1,
	connector1_type: 'Unknown',
	connector2_type: 'Unknown',
	remarks: '',
}

Vue.use(ServerTable)

export default {
	name: 'charger_brand_list',
	notifications,
	components: {
		ServerTable,
		Event,
		Multiselect,
		vSelect
	},
	data(){
		let app = this;
		let cannotEdit = app.$state.$get('ccff') === 'N/A' ? false : true;
		return {
			power_options: [
			{label:'AC', value:'AC'},
			{label:'DC', value:'DC'},
			],
			connector_type_options: [
			{label:'CCS1', value: 'CCS1'},
			{label:'CCS2', value: 'CCS2'},
			{label:'CHAdeMO', value: 'CHAdeMO'},
			{label:'TeslaTPC', value: 'TeslaTPC'},
			{label:'J1772_Type1', value: 'J1772_Type1'},
			{label:'Mennekes_Type2', value: 'Mennekes_Type2'},
			{label:'Others', value: 'Others'},
			{label:'Unknown', value: 'Unknown'}
			],
			edit_connector1_type: 'Unknown',
			edit_connector2_type: 'Unknown',
			cannotEdit,
			device_uri: '',
			showQrCode: false,
			showLogList: false,
			selected_row: null,

			editRowId: null,
			record: Object.assign({}, clean_form),
			showEditorModal: false,
			delRowShowModal: false,
			delRowId: 0,
			delRowMsg: '',
			columns: ['id', 'name', 'power', 'power_rating', 'connector1_type', 'connector2_type', 'remarks', 'created'],
			data: [],
			options: {
				debounce: 86400000, // 停止預設的即時搜尋
				headings: {
					id:	 'id',
					name: '名稱',
					power: '電源',
					power_rating: '功率',
					connector1_type: '充電槍1',
					connector2_type: '充電槍2',
					remarks: '備註',
					created: '建立時間'
				},
				orderBy: {
					column: 'id',
					ascending: false
				},
				sortable: ['id','name', 'power', 'power_rating', 'created'],
				filterable: ['name', 'power', 'power_rating'],
				sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
				pagination: {
					chunk: 5,
					edge: false,
					nav: 'scroll'
				},
				perPage: 25,
				requestFunction(data) {

					let action = `${admin_root}/get_list/ChargerBrand`;
					let params = {
						keyset: 'mqtt'
					};

					let ccff = this.$state.$get('ccff');
					if(ccff){
						params['ccff'] = ccff;
					}

					for(let col in data){
						params[col] = ''+data[col];
					}

					return fetch(action, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
						},
						body: JSON.stringify(params)
					}).then(res => res.json()).then(result => {
						return {
							data: result.data || [],
							count: result.count || 0
						};
					}).catch(error => {
						return {
							data: [],
							count: 0
						};
					});
				}//eo requestFunction
			},
			useVuex: false,
			theme: 'bootstrap4',
			template: 'default'
		};//eo return
	},//eo data

	mounted(){
		let app = this;
		// Search field 按下Enter後開始搜尋
		this.$nextTick(() => {
			let searchInput = document.querySelector('.VueTables__search-field input');
			if (searchInput) {
				// 取消 Vue Tables 內部的即時搜尋
				/*searchInput.addEventListener('input', (event) => {
					console.info('searchInput event:', event);
				}, true); // 捕獲模式，確保先執行*/

				// 監聽 Enter 鍵，才真正搜尋
				searchInput.addEventListener('keyup', (event) => {
					//console.info('keyup: ', event.key);
					//this.showSuccess({message:`key: ${event.key}`});
					if (event.key === "Enter" || event.key === "Go" || event.key === "Search") {
						this.$refs.dataTable.setFilter(searchInput.value);

						//強制清除 Vue Tables 內部的 debounce 計時器
						//this.$refs.dataTable.query = searchInput.value; // 直接覆寫內部值，避免 24 小時後觸發
					}
				});

				// 監聽 "失去焦點" (按 "下一步" 後，強制搜尋)
				searchInput.addEventListener('blur', () => {
					//console.info('blur event: 搜尋觸發');
					//this.showSuccess({message:'blur event: 搜尋觸發'});
					this.$refs.dataTable.setFilter(searchInput.value);
				});
			}
		});
	},

	methods: {
		editRow(row_id, row) {
			//console.info('row_id:', row_id, ', row:', row);
			this.edit_connector1_type = (row.connector1_type !== undefined) ? row.connector1_type : 'Unknown';
			this.edit_connector2_type = (row.connector2_type !== undefined) ? row.connector2_type : 'Unknown';

			this.selected_row = row;
			if(row.power == 'AC') {
				this.selected_row.select_power = {label:'AC', value:'AC'};
			} else {
				this.selected_row.select_power = {label:'DC', value:'DC'};
			}
			this.openEditor(row_id);
			this.record = Object.assign({}, this.selected_row);
		},//eo editRow

		delRow(row_id, row_name) {
			// console.info('del row_id:', row_id);
			this.delRowShowModal = row_id ? true : false;
			this.delRowId		 = row_id;
			this.delRowMsg		 = `您確定要刪除${row_name}嗎？`;
		},//eo delRow

		submitDelRow(row_id) {
			let app	   = this;
			let action = `${admin_root}/update_charger_brand`;
			let params = {
				keyset: 'mqtt',
				record: encodeURIComponent(encrypt(JSON.stringify({
					id: row_id,
					delete: 1
				})))
			};

			fetch(action, {
				method: 'POST',
				headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
				},
				body: JSON.stringify(params)
			}).then(res => res.json()).then(result => {
				if(result.success){
					app.showSuccess({
						title: '資料更新成功',
						message: result.message
					});

					app.$refs['dataTable'].refresh();
				} else {
					app.showError({
						title: '資料更新失敗',
						message: result.message
					});
				}
			}).catch(error => {
				app.showError({
					title: '資料更新失敗',
					message: result.message
				});
			});
		},

		testRow(row_id) {
			console.info('test row_id:', row_id);
			this.showWarn({
				message: '開發中',
				title: '功能暫停'
			});
		},//eo testRow

		chkState(val) {
		  const field = this.$v.record[val];

		  // console.info('this.$v.record[val]:', this.$v.record[val], ', v:', field.value);

		  return !field.$dirty || !field.$invalid;
		},

		openEditor(row_id){
			this.editRowId		 = row_id;
			this.showEditorModal = true;
			this.$v.$reset();
			let app		   = this;

			if(row_id && app.selected_row){
				//do nothing
			} else {
				app.record		 = Object.assign({}, clean_form);
				app.edit_connector1_type = 'Unknown';
				app.edit_connector2_type = 'Unknown';
				app.selected_row = null;
				app.row_id		 = null;
			}
		},

		submitRecord(event) {
			let app	   = this;
			let row_id = app.editRowId;
			this.$v.$touch();

			if (this.$v.$invalid) {
				this.showError({message:'請輸入必填欄位', title:'資料錯誤'});
				return false;
			}

			this.record.power = this.record.select_power.value;
			if(this.record.power == 'AC'){
				if(!this.record.voltage || this.record.voltage == '') {
					this.record.voltage = 220;
					//this.showError({message:'請輸入電壓欄位', title:'資料錯誤'});
					//return false;
				}
				if(!this.record.current_rating || this.record.current_rating == '') {
					this.record.current_rating = 32;
					//this.showError({message:'請輸入電流欄位', title:'資料錯誤'});
					//return false;
				}
			} else { //DC
				this.record.voltage = null;
				this.record.current_rating = null;
			}

			if(this.record.remarks == '') {
				this.record.remarks = null;
			}

			if(this.edit_connector1_type && this.edit_connector1_type.value !== undefined){
				this.record.connector1_type = this.edit_connector1_type.value;
			}

			if(this.edit_connector2_type && this.edit_connector2_type.value !== undefined){
				this.record.connector2_type = this.edit_connector2_type.value;
			}

			if(this.record.num_of_connector == 1) {
				this.record.connector2_type = 'Unknown';
			}
			
			let to_save = Object.assign({}, this.record);
			delete to_save.select_power;
			if(row_id){
				to_save['id'] = row_id;
			}

			//console.info('to_save:', to_save);
			to_save = encodeURIComponent(encrypt(JSON.stringify(to_save)));

			let action = `${admin_root}/save_charger_brand`;
			let params = {
				keyset: 'mqtt',
				record: to_save
			};

			fetch(action, {
				method: 'POST',
				headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + this.$state.$get('adminuser').token
				},
				body: JSON.stringify(params)
			}).then(res => res.json()).then(result => {
				if(result.success){
					app.showSuccess({
						title: '成功',
						message: '資料成功儲存'
					});
					app.$refs['dataTable'].refresh();
					app.record = Object.assign({}, clean_form);
					app.$v.$reset();
				} else {
					if (event) {
						event.preventDefault();
					}
					app.showError({
						title: '錯誤',
						message: '無法儲存資料，請稍後再試'
					});
					app.$refs['dataTable'].refresh();
				}
			}).catch(error => {
				if (event) {
					event.preventDefault();
				}
				app.showError({
				title: '錯誤',
				message: '無法儲存資料，請稍後再試'
				});
				app.$refs['dataTable'].refresh();
			});
		},
	},//eo methods

	validations: {
		record: {
			name: {
				required,
				minLength: minLength(2)
			},
			select_power: {
				required,
			},
			power_rating: {
				required,
				integer
			},
			num_of_connector: {
				required,
				integer
			}
		}
	},//eo validations
	
};
</script>
<style lang="scss">
.card-body{padding:0;}
.checkbox-container {display: flex;}
.checkbox-container .custom-checkbox {margin-right: 10px;}
.add-btn{}
.help-text{margin-top: 0.5rem; margin-left: 0.8rem;}
.multiselect__input{width:100%;border:none;}
#qrcode-canvas{
	display:inline-block;
	margin: auto;
}
#dataTable {
	width: 95%;
	margin: 0 auto;
	margin-top: 0.5rem;
	font-size: 0.75rem;

	.VuePagination {
	  text-align: center;
	  justify-content: center;
	}

	.vue-title {
	  text-align: center ;
	  margin-bottom: 10px;
	}

	.VueTables__search-field {
	  display: flex;
	}
	.VueTables__search-field input {
	  margin-left: 0.25rem;
	}

	.VueTables__limit-field {
	  display: flex;
	}

	.VueTables__limit-field select {
	  margin-left: 0.25rem !important;
	}

	.VueTables__table th {
	  text-align: center;
	}

	.VueTables__child-row-toggler {
	  width: 16px;
	  height: 16px;
	  line-height: 16px;
	  display: block;
	  margin: auto;
	  text-align: center;
	}

	.VueTables__child-row-toggler--closed::before {
	  content: "+";
	}

	.VueTables__child-row-toggler--open::before {
	  content: "-";
	}

	.VueTables__sortable {
		padding: 0.25rem;
	}
}
.modal .modal-xl {
	max-width: 90% !important;
	width: 90% !important;
}

</style>
